module.exports = __webpack_public_path__ + "img/pause.8f5ae172.svg";